<form #ngFormDirtyCheck="ngForm" [formGroup]="awardEntryForm">
    <div class="ams-title text-uppercase"><span>{{pageTitle}}</span></div>
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab [selected]="true">
            <ng-template kendoTabTitle>
                <h3>Award Information</h3>
            </ng-template>
            <ng-template kendoTabContent>
                <div class="row">
                    <div style="text-align:right" class="col-md-3 offset-md-9">
                        <button kendoButton [primary]="true" [icon]="'save'" (click)="saveAwardInformationEntry('')" [disabled]="isReadOnlyPage">
                            <span>save</span>
                        </button>
                        <button kendoButton class="awardEntrySave" style="display: none;" (click)="saveAwardInformationEntry('dirtyCheck')" ></button>
                        <button kendoButton [primary]="true" [icon]="'cancel'" (click)="cancelAwardInformationEntry()" [disabled]="isReadOnlyPage">
                            <span>cancel</span>
                        </button>
                    </div>
                </div>
                <fieldset>
                    <legend class="ams-legend-title">&nbsp;&nbsp;Award Information&nbsp;&nbsp;</legend>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Donor Agency" class="required-field">
                                <kendo-combobox [data]="donorAgencyList" [textField]="'agencyName'"
                                    [valueField]="'donorId'" [valuePrimitive]="true" formControlName="donorAgency"
                                    [filterable]="true" (filterChange)="handleDonorAgency($event)"
                                    (valueChange)="donorSelectionChange($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                                <span class="gps-validation-error text-left" *ngIf="donorAgencyValidate">Donor agency is
                                    required</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Donor Award Number">
                                <input kendoTextBox value="" formControlName="donorAwardNumber"  [readonly]="isReadOnlyPage">
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <label class="k-radio-label">Is EGPAF a sub to another organization?</label>
                            <div style="margin-top: 3%">
                                <input type="radio" value="Yes" id="subToAnotherOrganizationYes"
                                    (change)="subToAnotherOrganizationYes()" formControlName="subToAnotherOrganization"
                                    class="k-radio"  [attr.disabled]="isReadOnlyPage===true ? '': null" >
                                <label class="k-radio-label" for="subToAnotherOrganizationYes">Yes</label>
                                <input type="radio" value="No" id="subToAnotherOrganizationNo"
                                    (change)="subToAnotherOrganizationNo()" formControlName="subToAnotherOrganization"
                                    class="k-radio"  [attr.disabled]="isReadOnlyPage===true ? '': null">
                                <label class="k-radio-label" for="subToAnotherOrganizationNo">No</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div *ngIf="enablePrimeFunder">
                                <kendo-textbox-container floatingLabel="Prime Funder" class="required-field">
                                    <input kendoTextBox value="" formControlName="primeFunder" [readonly]="isReadOnlyPage">
                                    <span class="gps-validation-error text-left" *ngIf="primeFunderValidate">Primer
                                        funder is required</span>
                                </kendo-textbox-container>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <section class="mt-4">
                                <kendo-panelbar>
                                    <kendo-panelbar-item title="Donor POC" [expanded]="isEnableDonorContactList">
                                        <ng-template kendoPanelBarContent>
                                            <div class="card card-customize">
                                                <div class="card-block">
                                                    <section class="attachments-wrapper p-2">
                                                        <section class="attachments-wrapper">
                                                            <div class="row">
                                                                <div class="col-md-3">
                                                                    <kendo-textbox-container
                                                                        floatingLabel="Donor Contact">
                                                                        <input kendoTextBox value=""
                                                                            style="visibility:hidden; display:none"
                                                                            disabled />
                                                                        <kendo-multiselect [data]="donorContacts"
                                                                            [textField]="'name'"
                                                                            [valueField]="'contactId'"
                                                                            formControlName="donorContact" [disabled]="isReadOnlyPage"
                                                                            [valuePrimitive]="true" [filterable]="true"
                                                                            (filterChange)="handleDonorContact($event)"
                                                                            (valueChange)="donorContactSelectionChange($event)"
                                                                            (removeTag)="onRemoveDonorContact($event)">
                                                                            <ng-template
                                                                                kendoDropDownListHeaderTemplate>
                                                                                <button
                                                                                    (click)="createNewDonorContact(newDonorContactTemp)"
                                                                                    kendoButton [primary]="true"
                                                                                    [icon]="'add'"></button>
                                                                            </ng-template>
                                                                        </kendo-multiselect>
                                                                    </kendo-textbox-container>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <kendo-grid [data]="donorContactGrid"
                                                                        [columnMenu]="{sort: true, filter: true, columnChooser: false}"
                                                                        [pageSize]="donorContactGridPageSize"
                                                                        [skip]="skip"
                                                                        (pageChange)="donorContactGridPageChange($event)"
                                                                        (dataStateChange)="donorContactDataStateChange($event)"
                                                                        (filterChange)="donorContactFilterChange($event)"
                                                                        [pageable]="{
                                                                            buttonCount: buttonCount,
                                                                            info: info,
                                                                            type: typedg,
                                                                            pageSizes: pageSizes,
                                                                            previousNext: previousNext }"
                                                                        filterable="menu" [filter]="filter">
                                                                        <kendo-grid-column title="Name" field="name" [width]="150">
                                                                            <ng-template kendoGridHeaderTemplate let-column
                                                                                let-columnIndex="columnIndex">
                                                                                {{column.title}}
                                                                            </ng-template>
                                                                            <ng-template kendoGridFilterMenuTemplate
                                                                                let-column="column" let-filter="filter"
                                                                                let-filterService="filterService">
                                                                                <kendo-multiselect style="width:220px"
                                                                                    [data]="nameValue" textField="name"
                                                                                    valueField="name"
                                                                                    [valuePrimitive]="true"
                                                                                    [value]="categoryFilters(filter)"
                                                                                    (valueChange)="nameValueChange($event, filterService)">
                                                                                </kendo-multiselect>
                                                                            </ng-template>
                                                                            <ng-template kendoGridCellTemplate
                                                                                let-dataItem>
                                                                                <span> {{dataItem.name}}</span>
                                                                            </ng-template>
                                                                        </kendo-grid-column>
                                                                        <kendo-grid-column title="Title" field="title" [width]="150">
                                                                            <ng-template kendoGridHeaderTemplate let-column
                                                                                let-columnIndex="columnIndex">
                                                                                {{column.title}}
                                                                            </ng-template>
                                                                            <ng-template kendoGridFilterMenuTemplate
                                                                                let-column="column" let-filter="filter"
                                                                                let-filterService="filterService">
                                                                                <kendo-multiselect style="width:220px"
                                                                                    [data]="titleValue"
                                                                                    textField="title" valueField="title"
                                                                                    [valuePrimitive]="true"
                                                                                    [value]="categoryFilters(filter)"
                                                                                    (valueChange)="titleValueChange($event, filterService)">
                                                                                </kendo-multiselect>
                                                                            </ng-template>
                                                                            <ng-template kendoGridCellTemplate
                                                                                let-dataItem>
                                                                                <span> {{dataItem.title}}</span>
                                                                            </ng-template>
                                                                        </kendo-grid-column>
                                                                        <kendo-grid-column title="Email" field="email" [width]="150">
                                                                            <ng-template kendoGridHeaderTemplate let-column
                                                                                let-columnIndex="columnIndex">
                                                                                {{column.title}}
                                                                            </ng-template>
                                                                            <ng-template kendoGridFilterMenuTemplate
                                                                                let-column="column" let-filter="filter"
                                                                                let-filterService="filterService">
                                                                                <kendo-multiselect style="width:220px"
                                                                                    [data]="emailValue"
                                                                                    textField="email" valueField="email"
                                                                                    [valuePrimitive]="true"
                                                                                    [value]="categoryFilters(filter)"
                                                                                    (valueChange)="emailValueChange($event, filterService)">
                                                                                </kendo-multiselect>
                                                                            </ng-template>
                                                                            <ng-template kendoGridCellTemplate
                                                                                let-dataItem>
                                                                                <span> {{dataItem.email}}</span>
                                                                            </ng-template>
                                                                        </kendo-grid-column>
                                                                        <kendo-grid-checkbox-column
                                                                            title="Donor POC Compliance" [width]="150">
                                                                            <ng-template kendoGridCellTemplate
                                                                                let-dataItem let-idx="rowIndex">
                                                                                <input type="checkbox"
                                                                                    [checked]="dataItem.isPOCCompliance"
                                                                                    (change)="itemCheck(dataItem, $event, 'IsPOCCompliance')"
                                                                                    class="k-checkbox" [disabled]="isReadOnlyPage"/>
                                                                                <label class="k-checkbox-label"
                                                                                    [for]="dataItem.contactId"></label>
                                                                            </ng-template>
                                                                        </kendo-grid-checkbox-column>
                                                                        <kendo-grid-checkbox-column
                                                                            title="Donor POC Programmatic" [width]="150">
                                                                            <ng-template kendoGridCellTemplate
                                                                                let-dataItem let-idx="rowIndex">
                                                                                <input type="checkbox"
                                                                                    [checked]="dataItem.isPOCProgrammatic"
                                                                                    (change)="itemCheck(dataItem, $event, 'IsPOCProgrammatic')"
                                                                                    class="k-checkbox" [disabled]="isReadOnlyPage"/>
                                                                                <label class="k-checkbox-label"
                                                                                    [for]="dataItem.contactId"></label>
                                                                            </ng-template>
                                                                        </kendo-grid-checkbox-column>
                                                                    </kendo-grid>
                                                                </div>
                                                            </div>
                                                        </section>
                                                    </section>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </kendo-panelbar-item>
                                </kendo-panelbar>
                            </section>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <legend class="ams-legend-title">&nbsp;&nbsp;Award Details&nbsp;&nbsp;</legend>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="EGPAF Award Number" class="required-field">
                                <input kendoTextBox formControlName="egpafAwardNumber" (keyup)="validateAwardNumber($event)" [readonly]="isReadOnlyPage || isDisableAwardNumber">
                                <span class="gps-validation-error text-left" *ngIf="awardNumberValidate">Award
                                    number is required</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Award Title" class="required-field">
                                <input kendoTextBox value="" formControlName="awardTitle"  (keyup)="validateAwardTitle($event)" [readonly]="isReadOnlyPage">
                                <span class="gps-validation-error text-left" *ngIf="awardTitleValidate">Award title is
                                    required</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Award Nick Name" class="required-field">
                                <input kendoTextBox value="" formControlName="nickName"  (keyup)="validateAwardNickName($event)" [readonly]="isReadOnlyPage">
                                <span class="gps-validation-error text-left" *ngIf="awardNickNameValidate">Award nick name
                                    is required</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Award Status" class="required-field">
                                <kendo-dropdownlist [data]="agreementStatusList" [textField]="'statusName'"
                                    [valueField]="'agreementStatusId'" formControlName="awardStatus"
                                    [valuePrimitive]="true" [filterable]="true" [disabled]="isReadOnlyPage"
                                    (filterChange)="handleAwardStatus($event)">
                                </kendo-dropdownlist>
                                <span class="gps-validation-error text-left" *ngIf="awardStatusValidate">Award status is
                                    required</span>
                            </kendo-textbox-container>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Project Start Date">
                                <kendo-datepicker [format]="'dd MMM yyyy'" formControlName="projectStartDate"
                                (valueChange)="projectDateChange()" [disabled]="isReadOnlyPage">
                                </kendo-datepicker>
                                <span *ngIf="projectStartDateValid" class="gps-validation-error text-left">Please Select Project 
                                    Start Date</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Project Close Date">
                                <kendo-datepicker [format]="'dd MMM yyyy'" formControlName="projectCloseDate"
                                (valueChange)="projectDateChange()" [disabled]="isReadOnlyPage">
                                </kendo-datepicker>
                                <span *ngIf="projectDateRangeValid" class="gps-validation-error text-left">End date
                                    should be greater than start date</span>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Countries">
                                <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                                <kendo-multiselect [data]="countryList" [textField]="'name'"
                                    [valueField]="'countryOfficeId'" [valuePrimitive]="true" [filterable]="true"
                                    formControlName="baseCountry" (filterChange)="handleCountries($event)"
                                    (valueChange)="countrySelectionChange($event)"
                                    (removeTag)="onRemoveAgreementCountry($event)" [disabled]="isReadOnlyPage">
                                    <ng-template kendoDropDownListHeaderTemplate>
                                        <button (click)="createNewCountry(newCountryTemp)" kendoButton [primary]="true"
                                            [icon]="'add'" *ngIf="isAdminCheck"></button>
                                    </ng-template>
                                </kendo-multiselect>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Regions">
                                <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                                <kendo-multiselect [data]="regionList" [textField]="'countryRegionName'"
                                    [valueField]="'regionId'" [valuePrimitive]="true" [filterable]="true"
                                    formControlName="baseRegion" (filterChange)="handleRegions($event)"
                                    (valueChange)="regionSelectionChange($event)"
                                    (removeTag)="onRemoveAgreementRegion($event)" [disabled]="isReadOnlyPage">
                                    <ng-template kendoDropDownListHeaderTemplate>
                                        <button (click)="createNewRegion(newRegionTemp)" kendoButton [primary]="true"
                                            [icon]="'add'" *ngIf="isAdminCheck"></button>
                                    </ng-template>
                                </kendo-multiselect>
                            </kendo-textbox-container>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-3">
                            <label class="k-radio-label">Is this a multi-year project?</label>
                            <div style="margin-top: 3%">
                                <input type="radio" value="Yes" id="multiYearProjectYes" [attr.disabled]="isReadOnlyPage===true ? '': null"
                                    (change)="multiYearProjectYes()" formControlName="multiYearProject" class="k-radio">
                                <label class="k-radio-label" for="multiYearProjectYes">Yes</label>
                                <input type="radio" value="No" id="multiYearProjectNo" (change)="multiYearProjectNo()"
                                    formControlName="multiYearProject" class="k-radio" [attr.disabled]="isReadOnlyPage===true ? '': null">
                                <label class="k-radio-label" for="multiYearProjectNO">No</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div *ngIf="hasMultipleYear">
                                <kendo-textbox-container floatingLabel="How many years" style="width:300px"
                                    class="required-field">
                                    <kendo-numerictextbox [autoCorrect]="false" class="numerictext" [min]="0" [max]="9"
                                        style="width:300px;" formControlName="agreementYear" [format]="'n0'"
                                        (keypress)="isNumericAndMaxLength($event)" [disabled]="isReadOnlyPage"
                                        (valueChange)="isAwardYearUsed($event)">
                                    </kendo-numerictextbox>
                                    <div *ngIf="agreementYearValidate" class="gps-validation-error text-left">
                                        <span>Please enter a Agreement year</span>
                                    </div>
                                </kendo-textbox-container>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <legend class="ams-legend-title">&nbsp;&nbsp;EGPAF Point of Contacts&nbsp;&nbsp;</legend>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="EGPAF Project Manager">
                                <kendo-combobox id="dropdown-with-clear" [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="egpafProjectManager" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Award Maintainer">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="egpafAwardManager" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Project Sponsor">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="projectSponsor" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="A&C Officer">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="acOfficer" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="FACS Officer">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="facsOfficer" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Research POC">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="researchPOC" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Country/Program Officer">
                                <kendo-combobox [data]="allUsersList" [textField]="'displayName'"
                                    [valueField]="'id'" formControlName="countryProgramOfficer" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleAllUsersList($event)" [disabled]="isReadOnlyPage">
                                </kendo-combobox>
                            </kendo-textbox-container>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <legend class="ams-legend-title">&nbsp;&nbsp;Programmatic Information&nbsp;&nbsp;</legend>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <kendo-textbox-container floatingLabel="Technical Areas">
                                <kendo-multiselect [data]="technicalAreaList" [textField]="'description'"
                                    [valueField]="'technicalAreaId'" [valuePrimitive]="true" [filterable]="true"
                                    (filterChange)="handleTechnicalAreas($event)" formControlName="technicalArea"
                                    (valueChange)="technicalAreaSelectionChange($event)" [disabled]="isReadOnlyPage"
                                    (removeTag)="onRemovetechnicalArea($event)">
                                </kendo-multiselect>
                            </kendo-textbox-container>
                        </div>
                        <div class="col-md-3">
                            <label class="k-radio-label">Narrative/Summary:</label>
                            <textarea class="w-150" style="width:400px; background: white;
                        border-width: 1px;" formControlName="summaryText" kendoTextArea [readonly]="isReadOnlyPage"></textarea>
                        </div>
                    </div>
                </fieldset>
                <section>
                    <kendo-panelbar>
                        <kendo-panelbar-item title="Activity Manager"
                            [expanded]="showCountryOfImplementSection">
                            <ng-template kendoPanelBarContent>
                                <div class="card card-customize">
                                    <div class="card-block">
                                        <section class="attachments-wrapper p-2">
                                            <section class="attachments-wrapper">
                                                <kendo-grid [data]="countryImplementationGrid"
                                                    [columnMenu]="{sort: true, filter: true, columnChooser: false}"
                                                    [pageSize]="countryImplementationGridPageSize" [skip]="skip"
                                                    (pageChange)="countryImplementationGridPageChange($event)"
                                                    (dataStateChange)="countryImplementationDataStateChange($event)"
                                                    (filterChange)="countryImplementationFilterChange($event)"
                                                    [pageable]="{
                                                    buttonCount: buttonCount,
                                                    info: info,
                                                    type: typedg,
                                                    pageSizes: pageSizes,
                                                    previousNext: previousNext }" (add)="addHandler($event)"
                                                    (save)="saveHandler($event)" (edit)="editHandler($event)"
                                                    (remove)="removeHandler($event)" (cancel)="cancelHandler($event)"
                                                    filterable="menu" [filter]="filter">
                                                    <ng-template kendoGridToolbarTemplate>
                                                        <div class="row w-100">
                                                            <div style="text-align:right" class="col-md-3 offset-md-9">
                                                                <button kendoGridAddCommand [icon]="'add'" [disabled]="isReadOnlyPage"
                                                                    [primary]="true">Add new</button>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                    <kendo-grid-column title="Country" field="name" [width]="150">
                                                        <ng-template kendoGridEditTemplate let-column="column"
                                                            let-formGroup="formGroup" let-isNew="isNew">
                                                            <kendo-dropdownlist [data]="activityCountryList"
                                                                [textField]="'countryRegionName'"
                                                                [valueField]="'countryOfficeId'" [valuePrimitive]="true"
                                                                [filterable]="true" formControlName="cOICountry"
                                                                (filterChange)="handleCountries($event)">
                                                            </kendo-dropdownlist>
                                                        </ng-template>
                                                        <ng-template kendoGridFilterMenuTemplate let-column="column"
                                                            let-filter="filter" let-filterService="filterService">
                                                            <kendo-multiselect style="width:220px" [data]="countryValue"
                                                                textField="name" valueField="name"
                                                                [valuePrimitive]="true"
                                                                [value]="categoryFilters(filter)"
                                                                (valueChange)="countryValueChange($event, filterService)">
                                                            </kendo-multiselect>
                                                        </ng-template>
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                            <span> {{dataItem.name}}</span>
                                                        </ng-template>
                                                    </kendo-grid-column>
                                                    <kendo-grid-column title="Activity Manager" field="displayName" [width]="150">
                                                        <ng-template kendoGridEditTemplate let-column="column"
                                                            let-formGroup="formGroup" let-isNew="isNew">
                                                            <kendo-dropdownlist [data]="allUsersList"
                                                                [textField]="'displayName'" [valueField]="'id'"
                                                                [valuePrimitive]="true" [filterable]="true"
                                                                formControlName="cOIManager"
                                                                (filterChange)="handleAllUsersList($event)">
                                                            </kendo-dropdownlist>
                                                        </ng-template>
                                                        <ng-template kendoGridFilterMenuTemplate let-column="column"
                                                            let-filter="filter" let-filterService="filterService">
                                                            <kendo-multiselect style="width:220px" [data]="managerValue"
                                                                textField="displayName" valueField="displayName"
                                                                [valuePrimitive]="true"
                                                                [value]="categoryFilters(filter)"
                                                                (valueChange)="managerValueChange($event, filterService)">
                                                            </kendo-multiselect>
                                                        </ng-template>
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                            <span> {{dataItem.displayName}}</span>
                                                        </ng-template>
                                                    </kendo-grid-column>
                                                    <kendo-grid-column title="Activity" field="activityName" [width]="150">
                                                        <ng-template kendoGridEditTemplate let-dataItem let-isNew="isNew">
                                                            <input kendoTextBox [value]="dataItem.activityName" formControlName="activityName">
                                                        </ng-template>
                                                        <ng-template kendoGridFilterMenuTemplate let-column="column"
                                                            let-filter="filter" let-filterService="filterService">
                                                            <kendo-multiselect style="width:220px"
                                                                [data]="activityValue" textField="activityName"
                                                                valueField="activityName" [valuePrimitive]="true"
                                                                [value]="categoryFilters(filter)"
                                                                (valueChange)="activityValueChange($event, filterService)">
                                                            </kendo-multiselect>
                                                        </ng-template>
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                            <span> {{dataItem.activityName}}</span>
                                                        </ng-template>
                                                    </kendo-grid-column>
                                                    <kendo-grid-column title="Test" field="id" [hidden]="true">
                                                    </kendo-grid-column>
                                                    <kendo-grid-command-column title="Action" [width]="150">
                                                        <ng-template kendoGridCellTemplate let-isNew="isNew">
                                                            <button [icon]="'edit'" kendoGridEditCommand title="edit" [disabled]="isReadOnlyPage"></button>
                                                            <button [icon]="'delete'" kendoGridRemoveCommand title="delete" [disabled]="isReadOnlyPage"></button>
                                                            <button [icon]="isNew ? 'add' : 'save'" [title]="isNew ? 'add' : 'save'" kendoGridSaveCommand></button>
                                                            <button [icon]="'clear'" kendoGridCancelCommand title="clear"></button>
                                                        </ng-template>
                                                    </kendo-grid-command-column>
                                                </kendo-grid>
                                            </section>
                                        </section>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-panelbar-item>
                    </kendo-panelbar>
                </section>
                <section>
                    <kendo-panelbar>
                        <kendo-panelbar-item title="Documents" (click)="documentExpand($event)" [expanded]="documentExpandFlag">
                            <ng-template kendoPanelBarContent>
                                <div class="card card-customize" *ngIf="validateDocumentExpandFlag">
                                    <div class="card-block">
                                        <section class="attachments-wrapper p-2">
                                            <section class="attachments-wrapper">
                                                <app-document [agreementId]="agreementId" [awardNumber]="awardNumber" [awardStatus]="isReadOnlyPage"
                                                    [awardNickName]="awardNickName" [awardTitle]="awardTitle" [agreementYear]="agreementYear"
                                                    (eventEmit)="documentEmit($event)" [roles]="roles"></app-document>
                                            </section>
                                        </section>
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-panelbar-item>
                    </kendo-panelbar>
                </section>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab>
            <ng-template kendoTabTitle>
                <h3>Deliverables</h3>
            </ng-template>
            <ng-template kendoTabContent>
                <app-deliverable-entry [agreementId]="agreementId" [awardNumber]="awardNumber" [awardStatus]="isReadOnlyPage"
                    [awardNickName]="awardNickName" [awardTitle]="awardTitle" [roles]="roles">
                </app-deliverable-entry>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab>
            <ng-template kendoTabTitle>
                <h3>Prior Approvals</h3>
            </ng-template>
            <ng-template kendoTabContent>
                <app-prior-approvals [agreementId]="agreementId" [awardNumber]="awardNumber" [awardStatus]="isReadOnlyPage"
                    [awardNickName]="awardNickName" [awardTitle]="awardTitle" [roles]="roles">
                </app-prior-approvals>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab>
            <ng-template kendoTabTitle>
                <h3>Notes</h3>
            </ng-template>
            <ng-template kendoTabContent>
                <app-notes [agreementId]="agreementId" [awardNumber]="awardNumber" [awardStatus]="isReadOnlyPage"
                    [awardNickName]="awardNickName" [awardTitle]="awardTitle" [roles]="roles">
                </app-notes>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab>
            <ng-template kendoTabTitle>
                <h3>Database Usage History</h3>
            </ng-template>
            <ng-template kendoTabContent>
                <app-audit [agreementId]="agreementId"></app-audit>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
    <button type="submit" id="submitBtn" class="btn btn-success submit_btn d-none"></button>
</form>

<ng-template #newCountryTemp>
    <div class="row">
        <div class="col-md-12">
            <kendo-textbox-container floatingLabel="New Country Name">
                <input kendoTextBox (blur)="countryNameChange($event)" />
                <span class="gps-validation-error text-left" *ngIf="validateNewCountryName">Please enter valid country
                    name</span>
            </kendo-textbox-container>
        </div>
    </div>
    <br />
    <span class="spacer"></span>
    <div style="text-align:right">
        <button kendoButton type="button" (click)="addCountry()" [primary]="true">
            <span>Process</span>
        </button>
    </div>
</ng-template>

<ng-template #newRegionTemp>
    <form [formGroup]="newRegionTempForm">
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="New Country">
                    <kendo-dropdownlist [data]="regionCountryList" [textField]="'countryRegionName'"
                        [valueField]="'countryOfficeId'" [valuePrimitive]="true" [filterable]="true"
                        (selectionChange)="regionCountrySelectionChange($event)" formControlName="newRegionCountryList">
                    </kendo-dropdownlist>
                    <span class="gps-validation-error text-left" *ngIf="validateRegionCountry">Please select
                        country</span>
                </kendo-textbox-container>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <kendo-textbox-container floatingLabel="New Region">
                    <input kendoTextBox (blur)="newRegionNameChange($event)" formControlName="newRegion" />
                    <span class="gps-validation-error text-left" *ngIf="validateNewRegion">Please enter valid
                        region</span>
                </kendo-textbox-container>
            </div>
        </div>
        <br />
        <span class="spacer"></span>
        <div style="text-align:right">
            <button kendoButton type="button" (click)="addRegion()" [primary]="true">
                <span>Process</span>
            </button>
        </div>
    </form>
</ng-template>

<ng-template #newDonorContactTemp>
    <div class="row">
        <div class="col-md-6">
            <kendo-textbox-container floatingLabel="Name" class="required-field">
                <input kendoTextBox (blur)="donorContactNameChange($event)" />
                <span class="gps-validation-error text-left" *ngIf="validDonorContactName">Please enter valid
                    name</span>
            </kendo-textbox-container>
        </div>
        <div class="col-md-6">
            <kendo-textbox-container floatingLabel="Title" class="required-field">
                <input kendoTextBox (blur)="donorContactTitleChange($event)" />
                <span class="gps-validation-error text-left" *ngIf="validDonorContactTitle">Please enter valid
                    title</span>
            </kendo-textbox-container>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <kendo-textbox-container floatingLabel="Email" class="required-field">
                <input type="email" kendoTextBox (blur)="donorContactEmailChange($event)" />
                <span class="gps-validation-error text-left" *ngIf="validDonorContactEmail">Please enter valid
                    email</span>
                <span class="gps-validation-error text-left" *ngIf="invalidEmailFormat">Invalid email format</span>
            </kendo-textbox-container>
        </div>
        <!-- <div class="col-md-6">
            <kendo-textbox-container floatingLabel="Notes">
                <input kendoTextBox (blur)="donorContactNotesChange($event)" />
            </kendo-textbox-container>
        </div> -->
    </div>
    <br />
    <span class="spacer"></span>
    <div style="text-align:right">
        <button kendoButton type="button" (click)="manualyAddedDonorContact()" [primary]="true">
            <span>Process</span>
        </button>
    </div>
</ng-template>